<template>
    <div class="home_page">
        <div class="home_image">
            <img src="@/assets/home_image_2.png" alt="Home Image" />
        </div>
    </div>
    <div class="home_page_mobile">
        <img src="@/assets/mobile_home.png" alt="Home Image" />
    </div>
</template>
<script>
export default {
    name: 'HomePage',
    mounted() {
        console.log('Montado');
        console.log(document.querySelector('.home_page').clientWidth, document.querySelector('.home_page').clientHeight);
    }
    
};
</script>

<style>
@media(max-width: 922px) {
    .home_page {
        display: none;
    }
    .home_page_mobile {
        display: flex;
        justify-content: center;
        position: relative;
        margin: 2vh 0 0 0;
        align-items: center;
        height: 100vh; /* Full viewport height */
        width: 100vw; /* Full viewport width */
        background-color: #ffefbc;
    }
    .home_page_mobile img {
        width: 100%;
        margin: 5vh 0 auto;
        padding: 0;
    }
}

@media(min-width: 922px) {
    .home_page_mobile {
        display: none;
    }
    .home_page {
        display: flex;
        justify-content: space-around;
        position: relative;
        margin: 0 0 0 0;
        align-items: center;
    }
    .home_image {
        height: calc(100vh - 25vh); 
        width: 100%;
        display: flex;
    }
    .home_image img {
        width: 100%;
        height: auto;
        object-fit: cover;
    }
}
</style>